import {AutomationListScheduledTrigger} from "./AutomationListScheduledTrigger";

export class AutomationListTrigger {
    constructor({
                    //attributes
                    id= null,
                    automation_list_id= null,
                    name= '',
                    send_after_value= 0,
                    send_after_unit= 0,
                    fire_once= true,
                    active= true,
                    is_default_list= false,
                    has_schedule_trigger= false,
                    integration_name= 'hoop_mail',
                    integration_id= 0,
                    scheduled_trigger= null,
                    created_at= new Date(),
                    updated_at= new Date(),
                    extradata={},
                } = {}) {

        //fill attributes
        this.id=id;
        this.automation_list_id=automation_list_id;
        this.name=name;
        this.send_after_value=send_after_value;
        this.send_after_unit=send_after_unit;
        this.fire_once=fire_once;
        this.active=active;
        this.is_default_list=is_default_list;
        this.has_schedule_trigger=has_schedule_trigger;
        this.integration_name=integration_name;
        this.integration_id=integration_id;
        this.extradata=Object.assign({}, extradata);
        this.created_at=created_at;
        this.updated_at=updated_at;
        this.scheduled_trigger=scheduled_trigger?new AutomationListScheduledTrigger(scheduled_trigger):null;
    }

    static createDefaultTrigger(name){
        return new AutomationListTrigger({
            is_default_list:true,
            name : name
        })
    }

    haveScheduledTriggerConfigured(){
        return !!this.scheduled_trigger;
    }
}

export function createAutomationListTrigger(data={}) {
    return Object.freeze(new AutomationListTrigger(data));
}